import type { TFunction } from 'i18next';

import type { SelectOption } from '@/shared/ui';

import { getGroupByOptions, getMetricOptions, getTransportGroupOptions } from '../config/filter-options';

/**
 * Chart titles arrive from the API as fixed English text — "Stock on Hand",
 * "Transport - Dispatched". Legacy RITA instead composes them from the current
 * filter selection, and the wording differs per locale down to word order:
 * `Transported {{metric}} by {{group}}` against `{{metric}} Transportado por {{group}}`.
 * So the title is built here from the same option lists the filter bar renders,
 * and `ChartData.title` is overridden with the result.
 */
const labelOf = (options: SelectOption[], value?: string) =>
  options.find((option) => option.value === value)?.label ?? '';

/**
 * The measure the Display (Show metric on Transport) filter picked, as the filter
 * itself words it — legacy titled every dashboard chart's y axis with it.
 */
export const getMetricLabel = (t: TFunction, metric?: string) => labelOf(getMetricOptions(t), metric);

export const getTransportChartTitle = (t: TFunction, metric?: string, group?: string) =>
  t('welcome.transport.report.title', {
    metric: labelOf(getMetricOptions(t), metric),
    group: labelOf(getTransportGroupOptions(t), group)
  });

export const getWarehouseChartTitle = (t: TFunction, tab: 'soh' | 'movements', group?: string) =>
  t(tab === 'soh' ? 'welcome.warehouseSOH.report.title' : 'welcome.warehouse.report.title', {
    group: labelOf(getGroupByOptions(t), group)
  });
